<section class="eligibility-modal" role="document">
  <button
    type="button"
    class="eligibility-modal__close"
    [attr.aria-label]="'promotions.detail.eligibility.close' | translate"
    (click)="close()"
  >
    <img src="assets/img/promotions/detail/modal-close.svg" alt="" aria-hidden="true" />
  </button>

  <div class="eligibility-modal__header">
    <img
      class="eligibility-modal__icon"
      src="assets/img/promotions/detail/eligibility-warning.svg"
      alt=""
      aria-hidden="true"
    />
    <h2>{{ 'promotions.detail.eligibility.title' | translate }}</h2>
  </div>

  <div class="eligibility-modal__body">
    @if (modalData.variant === 'location_mismatch') {
      <p>
        {{
          'promotions.detail.eligibility.locationMismatch'
            | translate
              : {
                  eligibleLocation: modalData.eligibleLocation,
                  accountLocation: modalData.accountLocation || modalData.eligibleLocation
                }
        }}
      </p>
      <p>
        {{ 'promotions.detail.eligibility.legalWarning' | translate: { eligibleLocation: modalData.eligibleLocation } }}
      </p>
    } @else {
      <p>
        {{
          'promotions.detail.eligibility.confirmLocation' | translate: { eligibleLocation: modalData.eligibleLocation }
        }}
      </p>
      <label class="eligibility-modal__checkbox">
        <input type="checkbox" [checked]="isConfirmed()" (change)="isConfirmed.set($any($event.target).checked)" />
        <span>
          {{
            'promotions.detail.eligibility.confirmCheckbox'
              | translate: { eligibleLocation: modalData.eligibleLocation }
          }}
        </span>
      </label>
    }
  </div>

  <div class="eligibility-modal__actions" [class.eligibility-modal__actions--stacked]="isConfirmLocationVariant()">
    @if (isConfirmLocationVariant()) {
      <korviu-button
        class="eligibility-modal__action"
        color="tertiary"
        size="large"
        [disabled]="!isConfirmed()"
        (click)="confirm()"
      >
        {{
          'promotions.detail.eligibility.confirmButton' | translate: { eligibleLocation: modalData.eligibleLocation }
        }}
      </korviu-button>
      <korviu-button class="eligibility-modal__action" color="ghost" size="large" (click)="close()">
        {{ 'promotions.detail.eligibility.back' | translate }}
      </korviu-button>
    } @else {
      <korviu-button class="eligibility-modal__action" color="ghost" size="large" (click)="close()">
        {{ 'promotions.detail.eligibility.back' | translate }}
      </korviu-button>
      <korviu-button class="eligibility-modal__action" color="tertiary" size="large" (click)="confirm()">
        {{ 'promotions.detail.eligibility.continue' | translate }}
      </korviu-button>
    }
  </div>
</section>
